import React from 'react';
import BannerSection from '../../components/BannerSection';
import CallSection from '../../components/CallSection';
import CallToAction from '../../components/CallToAction';
import Footer from '../../components/Footer';
import HowWorksSection from '../../components/HowWorksSection';
import Navbar from '../../components/Navbar';
import PlayersWeekSection from '../../components/PlayersWeekSection';
import TournamentsSection from '../../components/TournamentsSection';

const Tournament = () => {
    return (
        <div>
            <Navbar />
            <BannerSection />
            <TournamentsSection />
            <PlayersWeekSection />
            <HowWorksSection />
            <CallToAction />
            <CallSection />
            <Footer />
        </div>
    );
}

export default Tournament;